/**
 * Equipment Issues Route Configuration
 */

import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const EquipmentIssues = lazy(() => import('./page'));

const EquipmentIssuesRoute: FuseRouteItemType = {
	path: '/equipment-issues',
	element: <EquipmentIssues />
};

export default EquipmentIssuesRoute;
